export default __webpack_public_path__ + "static/middle-east-110c3e2fbd33386d6c4a02bb4e59d1ec.png";